module.exports = __webpack_public_path__ + "static/media/photo-count.45d988fc.svg";